import styled from "styled-components";
import SideBar from "./SideBar";
import Header from "./Header";
import { Outlet } from "react-router-dom";
import { useState } from "react";
import ArrowLeftIcon from "@mui/icons-material/ArrowLeft";
import ArrowRightIcon from "@mui/icons-material/ArrowRight";
import { IconButton, Tooltip } from "@mui/material";

// Move styled components outside the functional component
const StyledAppLayout = styled.div`
  display: grid;
  grid-template-columns: ${(props) => (props.toggle ? "13rem" : "0rem")} 1fr;
  grid-template-rows: auto 1fr;
  height: 100vh;
  transition: grid-template-columns 0.3s ease-in-out;
`;

const Main = styled.main`
  background-color: #e9e9e9;
  padding: 0rem 1rem 0rem;
  overflow: auto;
  transition: background-color 0.3s ease-in-out;
`;

const StyleDiv = styled.div`
  background-color: #2c3e50;
  overflow: auto;
  grid-row: 1/-1;
  display: flex;
  flex-direction: column;
  gap: 3.2rem;
  transition: all 0.3s;
  z-index: 3000;
  transition: opacity 0.3s ease-in-out;
`;

const IconButtonWrapper = styled.div`
  position: fixed;
  top: 16px;
  left: ${(props) => (props.toggle ? "170px" : "16px")};
  z-index: 3000;
  transition: left 0.3s ease-in-out;
`;
export default function AppLayout() {
  const [toggle, setToggle] = useState(true);
  return (
    <StyledAppLayout toggle={toggle}>
      <IconButtonWrapper toggle={toggle}>
        <Tooltip title='toggle drawer'>
          <IconButton
            style={{ backgroundColor: "#ccc", borderRadius: "10px" }}
            size='small'
            onClick={() => setToggle(!toggle)}>
            {toggle ? <ArrowLeftIcon /> : <ArrowRightIcon />}
          </IconButton>
        </Tooltip>
      </IconButtonWrapper>
      <Header />
      {toggle ? <SideBar /> : <StyleDiv></StyleDiv>}
      <Main>
        <Outlet />
      </Main>
    </StyledAppLayout>
  );
}
